import { Divider } from '@hopskipdrive/react-components';
import { colorPalette, colorTokens, variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

const mqTablet = `@media (max-width: ${variables.breakpoints.tablet - 1}px)`;

export const TwoColGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  width: 100%;
  ${mqTablet} {
    grid-template-columns: 1fr;
  }
`;

export const FieldCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SectionDivider = styled(Divider)`
  &.MuiDivider-root {
    border-color: ${colorPalette.neutralVariant90};
    width: 100%;
  }
`;

export const ToggleStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ImageWithIcon = styled.div`
  position: relative;
  height: 96px;
  width: 96px;
  > div:last-of-type {
    position: absolute;
    right: 0%;
    bottom: 0%;
    border: 1px solid ${colorTokens.text.medium};
  }
`;

export const PhotoUploadInstructions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  width: 171px;
`;
